import React, { useState, useRef } from "react";
import { Breadcrumb, IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Persona, PersonaSize } from "@fluentui/react/lib/Persona";
import { Callout, DirectionalHint } from "@fluentui/react/lib/Callout";
import { Icon } from "@fluentui/react";

interface ITopBannerProps {
    customerTitle: string;
    userName: string;
    onLogout: () => void;
    breadcrumbItems?: IBreadcrumbItem[];
}

export const TopBanner: React.FC<ITopBannerProps> = ({
    customerTitle,
    userName,
    onLogout,
    breadcrumbItems
}) => {
    const personaInitials = userName
        ? userName.trim().substring(0, 2).toUpperCase()
        : "NA";

    const personaRef = useRef<HTMLDivElement | null>(null);
    const [showCallout, setShowCallout] = useState(false);

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: '20px',
                    paddingRight: '6px',
                    height: 48,
                    backgroundColor: "#F4F5F7",
                }}

            >
                {/* Left: Breadcrumb */}
                <div className="breadcrumb-wrapper" style={{ flex: 1, minWidth: 0, }}>
                    {breadcrumbItems && breadcrumbItems.length > 0 && (
                        <Breadcrumb
                            items={breadcrumbItems}
                            ariaLabel="Navigation breadcrumb"
                            overflowAriaLabel="More links"
                            //maxDisplayedItems={10}
                            //overflowIndex={breadcrumbItems.length > 1 ? breadcrumbItems.length - 2 : 0}
                            overflowIndex={breadcrumbItems.length > 1 ? 1 : 0}
                            styles={{
                                root: {
                                    width: "100%",
                                    minWidth: 0,
                                    color: "black",
                                    margin: 0,
                                },
                                itemLink: {
                                    color: "black",
                                    fontSize: 15,
                                    fontWeight: 'normal',

                                    selectors: {
                                        ':hover': {
                                            backgroundColor: '#E8E9EB',
                                            cursor: 'pointer'
                                        }
                                    }
                                },
                                item: {
                                    color: "black",
                                    fontSize: 15,
                                    fontWeight: 'normal',

                                    // selectors: {
                                    //     // *** THIS IS THE CRITICAL CHANGE ***
                                    //     // This targets the item element when it is the last child of the list.
                                    //     // It targets the item class when it is inside the last list item.
                                    //     '&': {
                                    //         // Force the font weight to normal on the item element itself
                                    //         fontWeight: 'normal',
                                    //     },

                                    //     // Also explicitly target the text wrapper element (ms-TooltipHost) 
                                    //     // which holds the text and might be where the bolding is applied.
                                    //     '& > .ms-TooltipHost': {
                                    //         fontWeight: 'normal',
                                    //     },
                                    // }
                                },

                                chevron: { color: "black" }
                            }}
                        />
                    )}

                </div>

                {/* Right: Persona */}
                <div
                    ref={personaRef}
                    style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: 5 }}
                    onClick={() => setShowCallout(!showCallout)}
                >
                    <Persona text={personaInitials} size={PersonaSize.size32} hidePersonaDetails />
                </div>

                {/* Callout */}

                {showCallout && personaRef.current && (
                    <Callout
                        target={personaRef.current}
                        onDismiss={() => setShowCallout(false)}
                        directionalHint={DirectionalHint.bottomRightEdge}
                        isBeakVisible={false}
                        setInitialFocus
                        gapSpace={4}
                        styles={{
                            calloutMain: { padding: 0, minWidth: 180 }
                        }}
                    >
                        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column" }}>
                            {/* User info */}
                            <div style={{ borderBottom: "1px solid #e1e1e1", paddingBottom: 8 }}>
                                <div style={{ fontWeight: 600, fontSize: 14 }}>{userName}</div>
                                <div style={{ fontSize: 12, color: "#666" }}>{customerTitle}</div>
                            </div>

                            {/* Logout action */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "8px 0",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    cursor: "pointer",
                                    //color: "#d13438",
                                    borderRadius: 4,
                                    transition: "background 0.2s"
                                }}
                                onClick={onLogout}
                                onMouseEnter={e => (e.currentTarget.style.background = "#f3f2f1")}
                                onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
                            >
                                <Icon iconName="SignOut" /> Logout
                            </div>
                        </div>
                    </Callout>
                )}

            </div>
        </>
    );
};
